<div class="flex flex-col w-full h-full justify-center items-center text-white bg-primary-700">
	<div class="text-4xl">{{ 'summary.summary_of_the_year' | translate }}</div>
	<div class="text-[300px] leading-none font-bold">{{ year() }}</div>
</div>
